import { capitalize } from "../../utils/capitalize";
import { DEFAULT_TIER } from "../../data/tierAccess";

// Coloured pill showing a seat's tier; falls back to the grandfather default
// for grants with no explicit tier. Styling (.tierPill / .tier-<tier>) lives in
// Account.css, loaded by the account screen that renders this.
export default function TierPill({ tier }) {
  const t = tier ?? DEFAULT_TIER;
  return <span className={`tierPill tier-${t}`}>{capitalize(t)}</span>;
}
